/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import useNavigate, { NavigateFunc } from "../../Utils/useNavigate";
import IViewHistoryContext from "./IViewHistoryContext";
import ViewHistoryEntry from "./ViewHistoryEntry";

export default class ViewHistoryContextInstance implements IViewHistoryContext {
    private readonly _navigate: NavigateFunc;
    private readonly _entries: ViewHistoryEntry[];
    private readonly _setEntries: React.Dispatch<React.SetStateAction<ViewHistoryEntry[]>>;

    public constructor() {
        [this._entries, this._setEntries] = useState<ViewHistoryEntry[]>([]);
        this._navigate = useNavigate();
    }

    public get entries(): ViewHistoryEntry[] {
        return this._entries;
    }

    public readonly register = (entry: ViewHistoryEntry) => () => {
        this._setEntries((prevEntries) => [...prevEntries, entry]);
        return () => {
            this._setEntries((prevEntries) => prevEntries.filter((e) => e.url !== entry.url));
        };
    };

    public closeCurrentView = () => {
        const reversedEntries = [...this.entries].reverse();
        const indexOfLastMainView = reversedEntries.findIndex((e) => !!e.isMainView);
        let url = window.location.href.indexOf("/buchungsportal") > 0 ? "/buchungsportal" : "/";
        if (indexOfLastMainView !== -1) {
            url = reversedEntries[indexOfLastMainView + 1]?.url ?? "";
        }

        this._navigate(url, { replace: false, enableChangeTracking: true });
    };
}
